
// export default Layout;
import React, { useState } from "react";
import "./Layout.css";
import SidebarComponent from "../Sidebar/Sidebar";
import HeaderComponent from "../Header/Header";
import { FaGripLines } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import "./DashboardLayout.css";

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isDashboard = /\/(admin|doctor)\/dashboard\/?$/.test(pathname);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() =>
    window.innerWidth >= 900
  );

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div
      className={`layout-main d-flex flex-column ${isDashboard ? "dashboard-layout" : ""} ${
        isSidebarOpen ? "sidebar-open" : "sidebar-closed"
      }`}
    >
      <SidebarComponent isOpen={isSidebarOpen} />
      {isSidebarOpen && (
        <button className="dashboard-sidebar-backdrop" aria-label="Close navigation" onClick={toggleSidebar} />
      )}
      <div className="layout-content">
        <HeaderComponent />
        <div className="toggle-box">
          <button onClick={toggleSidebar} className="sidebar-toggle-btn" aria-label={isSidebarOpen ? "Collapse navigation" : "Expand navigation"} aria-expanded={isSidebarOpen}>
            {isSidebarOpen ? " " : " "}
            <FaGripLines />
          </button>
        </div>

        <div className="inner-wrapper">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
